// Spanish translations
const es = {
  common: {
    loading: 'Cargando…', save: 'Guardar', cancel: 'Cancelar', back: 'Volver',
    edit: 'Editar', logout: 'Cerrar sesión', comingSoon: 'PRÓXIMAMENTE',
    error: 'Algo salió mal', retry: 'Reintentar', ofAura: 'AURA',
    yes: 'Sí', no: 'No', confirm: 'Confirmar', publish: 'Publicar',
    delete: 'Eliminar', more: 'Más',
  },
  nav: {
    home: 'Inicio', battles: 'Batallas', create: 'Crear', ranking: 'Ranking',
    discover: 'Descubrir', profile: 'Perfil', admin: 'Admin',
    notifications: 'Notificaciones', search: 'Buscar', saved: 'Guardados',
  },
  auth: {
    title: 'Entra al Aura', subtitle: 'Farmea tu Aura. Sube de rango.',
    signIn: 'Iniciar sesión', signUp: 'Registrarme',
    signInWithGoogle: 'Continuar con Google', signInWithPhone: 'Continuar con celular',
    orDivider: 'o',
    phone: 'Número de celular', phoneHint: 'Incluye código de país, ej. +52 55 0000 0000',
    password: 'Contraseña', passwordHint: '8+ caracteres',
    name: 'Nombre completo',
    username: 'Nombre de usuario', usernameHint: '3-24 caracteres, letras, números y _',
    usernameChecking: 'Verificando…', usernameAvailable: '✓ Disponible', usernameTaken: '✗ No disponible',
    birthdate: 'Fecha de nacimiento', country: 'País', state: 'Estado / Provincia', city: 'Ciudad',
    acceptTerms: 'Acepto los Términos y Condiciones', acceptPrivacy: 'Acepto la Política de Privacidad',
    acceptCommunity: 'Acepto las Normas de Comunidad',
    submitSignIn: 'Entrar', submitSignUp: 'Empezar a farmear Aura',
    switchToSignUp: '¿No tienes cuenta? Regístrate',
    switchToSignIn: '¿Ya tienes cuenta? Inicia sesión',
    errorInvalid: 'Credenciales inválidas', errorAccept: 'Debes aceptar los documentos obligatorios',
  },
  profile: {
    edit: 'Editar perfil', follow: 'Seguir', following: 'Siguiendo', unfollow: 'Dejar de seguir',
    challenge: 'Retar a batalla',
    followers: 'Seguidores', followingLabel: 'Siguiendo',
    posts: 'Publicaciones', battles: 'Batallas', wins: 'Victorias', losses: 'Derrotas', ties: 'Empates',
    winRate: '% Victorias', streak: 'Racha', bestStreak: 'Mejor racha',
    localRank: 'Ranking local', nationalRank: 'Ranking nacional', worldRank: 'Ranking mundial',
    badges: 'Insignias', noBadges: 'Aún sin insignias — gana una batalla para obtener la primera.',
    auraHistory: 'Historial de Aura', noTransactions: 'Aún sin movimientos de Aura.',
    nextLevel: 'para', progressLabel: 'Progreso',
    bio: 'Biografía', bioPlaceholder: 'Cuéntale a la comunidad sobre tu Aura…',
    changeAvatar: 'Cambiar avatar', uploadAvatar: 'Subir avatar',
    saved: 'Perfil guardado',
    yourQr: 'Tu Aura QR', scanToView: 'Escanea para ver el perfil',
    copyLink: 'Copiar enlace', linkCopied: 'Enlace copiado',
    tabs: { posts: 'POSTS', battles: 'BATTLES', aura: 'AURA', badges: 'BADGES' },
    noPosts: 'Sin publicaciones aún.',
    topMoments: 'Top Aura Moments',
    myStats: 'Mis Estadísticas',
  },
  home: {
    heroTitle: 'Farmea tu Aura',
    heroSub: 'Tu energía en números. Sube momentos, gana batallas, escala en el ranking.',
    yourAura: 'Tu Aura', trendingSoon: 'Las batallas llegan en la próxima entrega',
  },
  feed: {
    tabForYou: 'PARA TI', tabFollowing: 'SIGUIENDO',
    empty: 'Aún no hay nada — sigue creadores para llenar este feed.',
    emptyForYou: 'El Aura está calentando. Sé el primero en subir un momento.',
    signInToComment: 'Inicia sesión para comentar.',
    comments: 'Comentarios', noComments: 'Sé el primero en comentar.',
    reply: 'Responder', replyingTo: 'Respondiendo a',
    commentPlaceholder: 'Escribe un comentario…',
    linkCopied: 'Enlace copiado',
    reactionsLabel: 'Aura reactions', viewsLabel: 'visualizaciones',
    delete: 'Eliminar publicación', deleted: 'Publicación eliminada',
    confirmDelete: '¿Eliminar permanentemente esta publicación?',
    report: 'Reportar', mute: 'Silenciar usuario', blocked: 'Usuario bloqueado',
    muted: 'Usuario silenciado', block: 'Bloquear usuario',
    reportSubmitted: 'Reporte enviado',
    reportDescPlaceholder: 'Agrega más detalles (opcional)…',
    reportReasons: {
      harassment: 'Acoso', threats: 'Amenazas', hate_speech: 'Discurso de odio',
      sexual_content: 'Contenido sexual', violence: 'Violencia', spam: 'Spam',
      aura_fraud: 'Fraude de Aura', impersonation: 'Suplantación',
      privacy: 'Privacidad', minor_content: 'Contenido de menores', other: 'Otro',
    },
    liveBattleTitle: 'AURA BATTLE EN VIVO',
    watchBattle: 'Ver batalla',
    voteNow: 'Votar ahora',
    createTitle: '¿Qué vas a compartir?',
    create: {
      aura_moment: 'Aura Moment', aura_momentDesc: 'Una acción, estilo o vibra que genera Aura',
      video: 'Video', videoDesc: 'Hasta 60s en vertical',
      photo: 'Foto', photoDesc: 'Una foto con descripción',
      text: 'Texto', textDesc: 'Hasta 500 caracteres',
      positive: 'Acción positiva', positiveDesc: 'Reconoce un acto positivo (Community Aura)',
    },
    createText: 'Nueva publicación de texto', createPhoto: 'Nueva foto', createVideo: 'Nuevo video',
    createAuraMoment: 'Nuevo Aura Moment', createPositive: 'Acción positiva',
    caption: 'Descripción', captionPlaceholder: '¿De qué se trata este momento?',
    textPlaceholder: 'Comparte algo que valga Aura…',
    category: 'Categoría', privacy: '¿Quién puede ver?',
    privacyPublic: 'Público', privacyFollowers: 'Seguidores', privacySelf: 'Solo yo',
    picture: 'Elige una foto', picVideo: 'Elige un video', pickFile: 'Seleccionar archivo',
    publishing: 'Publicando…', published: 'Publicado',
    positiveNotice: 'Reconocer una acción entrega Aura solo después de que Community Aura la valide con testigos. Disponible pronto.',
    videoTooLong: 'Video muy largo. Máx 60 segundos.',
  },
  discover: {
    title: 'Descubrir', trending: 'Tendencias', creators: 'Top creadores',
    categories: 'Categorías', hashtags: 'Hashtags',
  },
  notifications: {
    title: 'Notificaciones', tabs: { all: 'Todas', battles: 'Batallas', aura: 'Aura', social: 'Social' },
    markRead: 'Marcar todo como leído', empty: 'Sin notificaciones aún.',
    types: {
      follow: 'te siguió',
      reaction: 'reaccionó a tu publicación',
      comment: 'comentó en tu publicación',
      reply: 'respondió tu comentario',
      mention: 'te mencionó',
      tag: 'te etiquetó',
      battle: 'actividad de batalla',
      vote: 'votó en tu batalla',
      aura_recognized: 'Aura reconocida',
      badge: 'Insignia obtenida',
    },
  },
  search: {
    title: 'Buscar', placeholder: 'Buscar usuarios, hashtags, publicaciones…',
    users: 'Usuarios', hashtags: 'Hashtags', posts: 'Publicaciones',
    empty: 'Empieza a escribir para encontrar a alguien.',
    noResults: 'Sin resultados.',
  },
  admin: {
    title: 'Panel Admin', totalUsers: 'Usuarios totales', activeUsers: 'Usuarios activos',
    newUsers7d: 'Nuevos (7d)', totalAura: 'Aura generada', distribution: 'Distribución por nivel',
    userList: 'Usuarios', search: 'Buscar…',
    notAllowed: 'No tienes permiso para acceder a esta zona.',
    content: 'Contenido', reports: 'Reportes',
  },
  levels: { npc: 'NPC', rookie: 'Rookie Aura', farmer: 'Aura Farmer',
    master: 'Aura Master', legend: 'Aura Legend', god: 'AURA GOD', max: 'NIVEL MÁXIMO' },
  toast: { followed: 'Ahora sigues', unfollowed: 'Dejaste de seguir', error: 'La acción falló' },
  qr: {
    copied: 'Enlace copiado', shareText: 'Rétame en AURA',
    scan: 'Escanear', share: 'Compartir', copyLink: 'Copiar enlace',
    privacyTitle: 'Quién puede retarme',
    privacy: { all: 'Todos', followers: 'Mis seguidores', following: 'Personas que sigo', none: 'Nadie' },
  },
  scan: {
    title: 'Escanea al contrincante', subtitle: 'Apunta tu cámara al Aura QR',
    invalid: 'Aura QR inválido', cameraDenied: 'Permiso de cámara denegado',
    youScanned: 'Has escaneado a',
    challenge: 'Retar a batalla', challengeSent: 'Reto enviado',
    scanAgain: 'Escanear otra vez',
    reasonClosed: 'Este usuario no acepta retos por ahora.',
    reasonSelf: 'Este es tu propio QR.',
    reasonFollowers: 'Solo sus seguidores pueden retarle.',
    reasonFollowing: 'Solo personas que sigue pueden retarle.',
  },
  battles: {
    myQr: 'Mi Aura QR', scanOpponent: '⚔️ Escanear contrincante',
    incoming: 'Retos entrantes', outgoing: 'Enviados', waiting: 'Esperando respuesta…',
    accepted: '¡Batalla aceptada!', declined: 'Reto rechazado',
    live: 'BATALLAS EN VIVO', noLive: 'No hay batallas ahora — escanea un contrincante para empezar.',
    watch: 'Ver batalla', preparing: 'Alista', voteNow: 'VOTAR AHORA',
    history: 'Historial',
  },
  battle: {
    preparing: 'Preparando', liveNow: 'En vivo', votingOpen: 'Votación abierta',
    startsIn: 'LA BATALLA COMIENZA EN', startBattle: 'Iniciar batalla', openVoting: 'Abrir votación',
    closesIn: 'Votación cierra en',
    voteFor: 'Votar por',
    voteRecorded: 'Tu voto ha sido registrado',
    waitResults: 'Los resultados aparecerán cuando cierre la votación.',
    contestantsCannotVote: 'Los contendientes no pueden votar en su propia batalla.',
    cannotVote: 'No puedes votar en esta batalla.',
    tied: 'EMPATE', tiedDesc: 'Un juez o revancha decidirá.',
    winner: 'GANADOR',
    votes: 'votos', totalVotes: 'votos totales',
    auraAwarded: 'Aura entregada',
  },
};
export default es;
